import React, { Fragment, Component } from 'react';
import
{
    Nav, NavItem, NavLink, TabContent, TabPane, Button, ListGroup, ListGroupItem, Label, UncontrolledTooltip
} from 'reactstrap';
import default_profile_image from '../../assets/DVTools/images/default_profile_image.jpg';
import Image from '../../helpers/Components/Image/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faEdit, faTrash, faCopy } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';
import * as PlayerUtils from '../PlayerUI/js/index';
export default class CommentsPart extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {}
    }
    onCopyEmbedClick = () =>
    {
        PlayerUtils.copyToClipboard(this.props.videoData.embed_text);
    }
    clearComment = () =>
    {
        this.commentText.value = "";
        this.commentText.blur();
        document.getElementById("div_all_comments").scrollTop = 0;
    }
    render()
    {
        return <div className="pane-content" style={this.props.videoData.is_dark === true ? { backgroundColor: "#1f1f1f", color: "white" } : null}>
            <Nav tabs="true">
                {this.props.videoData.show_comments === true ? < NavItem >
                    <NavLink href="javascript:void(0);"
                        className={classnames({ active: this.props.commentsActiveTab === '1', darkNav: this.props.videoData.is_dark === true && this.props.commentsActiveTab === '1' })}
                        onClick={() =>
                        {
                            this.props.commentsToggle('1');
                        }}
                        style={this.props.videoData.is_dark === true ? { color: "white" } : null}
                    >
                        Comments
                                                </NavLink>
                </NavItem> : null}
                {this.props.videoData.show_fb_comments === true ? <NavItem>
                    <NavLink href="javascript:void(0);"
                        className={classnames({ active: this.props.commentsActiveTab === '2', darkNav: this.props.videoData.is_dark === true && this.props.commentsActiveTab === '2' })}
                        onClick={() =>
                        {
                            this.props.commentsToggle('2');
                        }}
                        style={this.props.videoData.is_dark === true ? { color: "white" } : null}
                    >
                        Facebook comments
                                                </NavLink>
                </NavItem> : null}
                {this.props.videoData.is_owner === true ? < NavItem >
                    <NavLink href="javascript:void(0);"
                        className={classnames({ active: this.props.commentsActiveTab === '3', darkNav: this.props.videoData.is_dark === true && this.props.commentsActiveTab === '3' })}
                        onClick={() =>
                        {
                            this.props.commentsToggle('3');
                        }}
                        style={this.props.videoData.is_dark === true ? { color: "white" } : null}
                    >
                        Embed Code
                                                </NavLink>
                </NavItem> : null}
            </Nav>
            <TabContent activeTab={this.props.commentsActiveTab}>
                <TabPane tabId="1">
                    < Label style={{ width: "100%", textAlign: "center" }}>{this.props.videoData.comments_count > 0 ? "All Comments (" + this.props.videoData.comments_count + ")" : "Be the first to comment here"}</Label>
                    < div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                            <div className="widget-content-left mr-3">
                                <Image width={38} src={default_profile_image} fallbackSrc={default_profile_image} style={{ borderBottomLeftRadius: "50%", borderBottomRightRadius: "50%", borderTopLeftRadius: "50%", borderTopRightRadius: "50%" }} />
                            </div>
                            <div className="widget-content-left" style={{ width: "100%" }}>
                                <input placeholder="Type comment Here" style={{ width: "100%", height: "50px" }} onKeyUp={this.props.onTypeComment} ref={i => this.commentText = i} />
                            </div>

                        </div>
                        <hr />
                    </div>

                    <div style={{ maxHeight: "200px", overflowY: "auto" }} id="div_all_comments">  <ListGroup className="rm-list-borders rm-list-borders-scroll" flush>

                        {this.props.videoData.video_comments.map((item) =>
                        {
                            return <ListGroupItem style={this.props.videoData.is_dark === true ? { backgroundColor: "#1f1f1f", color: "white" } : null}>
                                <div className="widget-content p-0">
                                    <div className="widget-content-wrapper">
                                        <div className="widget-content-left mr-3">
                                            <Image width={38} src={item.user_image} fallbackSrc={default_profile_image} style={{ borderBottomLeftRadius: "50%", borderBottomRightRadius: "50%", borderTopLeftRadius: "50%", borderTopRightRadius: "50%" }} />
                                        </div>
                                        <div className="widget-content-left" style={{ width: "100%" }}>
                                            <div className="widget-heading">{item.user_name}<b className="text-primary">&nbsp;{item.date}</b></div>
                                            {item.showEditInput === false ?
                                                <div className="widget-subheading opacity-7" style={{ wordBreak: "break-word" }}>{item.comment}</div>
                                                : <div className="widget-subheading opacity-7" style={{ wordBreak: "break-word" }}>
                                                    <input style={{ width: "100%" }} id={"txt_comment_" + item.comment_guid} value={item.comment} onKeyDown={(e) => { this.props.onCommentKeyUp(e, item) }} onChange={(e) => { this.props.onCommentValueChanged(e, item) }} />
                                                    <br />
                                                    <label>Press Esc to<Button color="link" onClick={() => { this.props.cancelCommentChange(item) }} style={{ marginTop: "-3px", padding: "3px" }}>cancel</Button></label>
                                                </div>}
                                        </div>
                                        <div className="widget-content-right">
                                            {item.can_edit_delete === true ? <div style={{ float: "right" }}>
                                                <Button className="btn-open-options mr-2" id={"edit_comment" + item.guid} color="link" onClick={() => { this.props.onEditCommentClick(item.comment_guid) }}>
                                                    <FontAwesomeIcon icon={faEdit} fixedWidth={false} size="sm" />
                                                </Button>
                                                <UncontrolledTooltip placement="top" target={"edit_comment" + item.guid}>
                                                    Edit comment
                                                                                                </UncontrolledTooltip>
                                                <Button className="border-0 btn-transition" outline
                                                    title="Delete comment"
                                                    color="danger"
                                                    onClick={() => { this.props.onDeleteCommentClick(item.comment_guid) }}>
                                                    <FontAwesomeIcon icon={faTrash} style={{ fontSize: "14px" }} />
                                                </Button>

                                            </div> : null}
                                        </div>
                                    </div>
                                </div>
                            </ListGroupItem>
                        })}
                        {this.props.videoData.show_more_comments === true ? < ListGroupItem > <Button color="link" onClick={this.props.showMoreComments}>Show more comments</Button></ListGroupItem> : null}
                    </ListGroup>

                    </div>
                </TabPane>
                <TabPane tabId="2">
                    <div>
                        <div className="fb-comments" style={{ backgroundColor:"white" }} data-href={this.props.facebook_comments_url} data-numposts="10"></div>
                    </div>
                </TabPane>
                <TabPane tabId="3">
                    {/*<input type="text" style={{ width: "100%" }} placeholder="video embed url" value={this.props.videoData.embed_text} readOnly={true} />*/}
                    <Label>{this.props.videoData.embed_text}</Label>
                    <Button onClick={this.onCopyEmbedClick} color="link"><FontAwesomeIcon icon={faCopy} fixedWidth={false} size="sm" /> Copy</Button>
                </TabPane>
            </TabContent>
        </div>
    }
}